<template>
  <div :class="$style.auth">
    <div class="pt-5 pb-5 d-flex align-items-end mt-auto">
      <img class="logo-login" :src="icon_logo" alt="Logo Farmatodo" />
      <!-- <div class="air__utils__logo__text">
        <div class="air__utils__logo__name text-uppercase text-dark font-size-21">AIR UI</div>
        <div class="air__utils__logo__descr text-uppercase font-size-12 text-gray-6">Admin template</div>
      </div> -->
    </div>
    <div class="pl-5 pr-5 pt-5 pb-5 bg-white text-center" :class="$style.container">
      <div class="text-dark font-size-30 mb-2 text-center">Bienvenidos a CMS Farmatodo</div>
      <div class="text-muted text-center mb-4">Por favor ingrese su usuario y contraseña</div>
      <a-form class="mb-4" :form="form" @submit="handleSubmit">
        <a-form-item>
          <a-input
            size="large"
            placeholder="Email"
            v-decorator="['email', { initialValue: '', rules: [{ required: true, message: 'Por favor ingrese un usuario' }]}]"
          />
        </a-form-item>
        <a-form-item>
          <a-input
            size="large"
            placeholder="Contraseña"
            type="password"
            v-decorator="['password', {initialValue: '', rules: [{ required: true, message: 'Por favor ingresar una contraseña!' }]}]"
          />
        </a-form-item>
        <a-button
          type="primary"
          htmlType="submit"
          size="large"
          class="text-center btn btn-primary w-100 font-weight-bold font-size-18"
        >Ingresar</a-button>
      </a-form>
      <!-- <a
        href="#"
        class="font-weight-bold font-size-18 text-dark btn btn-outline-light w-100 mb-3"
        :class="$style.googleSign"
        :style="{ backgroundImage: 'url(resources/images/icons/google-logo.svg)' }"
      >Log in with Google</a> -->
      <router-link
        to="/system/forgot-password"
        class="text-blue font-weight-bold font-size-18"
      >¿Olvidé la contraseña?</router-link>
    </div>
    <!-- <div class="text-center font-size-18 pt-4 mb-auto">
      Don't have an account?
      <router-link to="/system/register" class="font-weight-bold text-blue text-underlined">
        <u>Sign Up</u>
      </router-link>
    </div> -->
    <div class="mt-auto pb-5 pt-5">
      <!-- <ul
        class="list-unstyled d-flex mb-2 flex-wrap justify-content-center"
        :class="$style.footerNav"
      >
        <li>
          <a href="#">Terms of Use</a>
        </li>
        <li>
          <a href="#">Compliance</a>
        </li>
        <li>
          <a href="#">Support</a>
        </li>
        <li>
          <a href="#">Contacts</a>
        </li>
      </ul> -->
      <div class="text-gray-1 text-center">© 2019 Farmatodo. Todos los derechos reservados.</div>
    </div>
  </div>
</template>
<script>
import { countryConfig } from '../../../../country-config/country-config'
export default {
  name: 'AirLogin',
  data() {
    return {
      form: this.$form.createForm(this),
      icon_logo: countryConfig.isColombia ? 'resources/images/logo-farmatodo-col.svg' : 'resources/images/logo-farmatodo-vzla.svg'
    }
  },
  methods: {
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$nprogress.start()
          this.$auth.login(values.email, values.password)
            .then(() => {
              this.$nprogress.done()
              this.$router.push('/')
              this.$notification['success']({
                message: 'Bienvenidos',
                description: 'Ha iniciado sesión correctamente!',
              })
            })
            .catch((error) => {
              this.$nprogress.done()
              this.$notification['warning']({
                message: error.code,
                description: error.message,
              })
            })
        }
      })
    },
  },
}
</script>
<style lang="scss" module>
@import "@/components/system/Auth/style.module.scss";
</style>
